export default "__VITE_ASSET__C9$umqnG__"